class Slider extends BaseClass {
    constructor(i, items, controls, nav) {
        super(i);
        this.wrap = i;
        this.items = items;
        this.nav = nav;
        this.controls = controls;
        this.style = this.wrap.dataset.style;
        this.options = {};

        this.buildSlider();
    }

    buildSlider() {

        let options = {};

        switch (this.style) {
            case "1":
                options = {
                    nav: false,
                    container: this.items,
                    controlsContainer: this.controls,
                    speed: 500,
                    autoHeight: true
                };
                break;
            case "2":
                options = {
                    navContainer: this.nav,
                    container: this.items,
                    controlsContainer: this.controls,
                    speed: 500,
                    autoHeight: true,
                    center: true,
                    gutter: 20,
                    fixedWidth: 300,
                    responsive: {
                        576: {
                            gutter: 20,
                            fixedWidth: 500 //540
                        },
                        768: {
                            gutter: 30,
                            fixedWidth: 660 //720
                        },
                        992: {
                            gutter: 30,
                            fixedWidth: 900 //960
                        },
                        1200: {
                            gutter: 40,
                            fixedWidth: 1060 //1140
                        },
                        1440: {
                            gutter: 40,
                            fixedWidth: 1320 //1400
                        }
                    }
                };
                break;
            default:
                options = {
                    container: this.wrap
                }
        }

        this.sliderObject = tns(options);

        this.wrap.sliderFunc = this.sliderObject;

        this.resizeFunction = debounce(e => {
            this.sliderObject.updateSliderHeight();
            this.raiseEvent("resized");
        }, 500).bind(this);

        window.addEventListener("resize", e => {
            this.resizeFunction();
        });


    }

}

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-slider]').forEach(i => {

        let theSlider = new Slider(i,
            i.querySelector('[data-items]'),
            i.querySelector('[data-controls]'),
            i.querySelector('[data-nav]')
        );
        i.sliderFunc = theSlider;

    })
});